module.exports = __webpack_public_path__ + "static/speaking-c8f39e675236c1a60229928aad52ab6b.jpg";